export const SET_BREADCRUMBS = 'SET_BREADCRUMBS';
export const emptyBredcrumbs = {
    account: {},
    showAccount: false,
    client: {},
    showClient: false,
    label: '',
};
